// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1__Q8","cls2":"Base-cls2__CC Base-cls1__Q8"};